import { Icon } from "./Icons";
import { capabilities } from "../data";

export function Capabilities() {
  return (
    <section className="relative bg-white py-24">
      <div className="mx-auto max-w-7xl px-6">
        <div className="mx-auto max-w-2xl text-center">
          <span className="text-xs font-bold uppercase tracking-[0.3em] text-teal-600">
            The Innovation Engine
          </span>
          <h2 className="mt-4 text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl">
            Capabilities that power global infrastructure
          </h2>
          <p className="mt-4 text-slate-500">
            Four integrated disciplines that move every project from blueprint
            to breakthrough with measurable precision.
          </p>
        </div>

        <div className="mt-16 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {capabilities.map((c) => (
            <div
              key={c.title}
              className="group relative overflow-hidden rounded-lg border border-slate-100 bg-gradient-to-b from-white to-slate-50 p-6 transition hover:-translate-y-1 hover:border-teal-200 hover:shadow-xl hover:shadow-teal-900/10"
            >
              <div className="absolute -right-8 -top-8 h-24 w-24 rounded-full bg-teal-500/5 transition group-hover:scale-150" />
              <div className="relative flex h-12 w-12 items-center justify-center rounded-md bg-gradient-to-br from-teal-600 to-cyan-500 text-white shadow-sm shadow-teal-600/30">
                <span className="h-6 w-6">
                  <Icon name={c.icon} />
                </span>
              </div>
              <h3 className="relative mt-6 text-lg font-semibold text-slate-900">
                {c.title}
              </h3>
              <p className="relative mt-3 text-sm leading-relaxed text-slate-500">
                {c.text}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
